import React, { useCallback, useEffect, useMemo } from 'react';
import { useStore } from 'common/store';
import { SelectValueViewer } from 'components';
import { useFundOwnershipContext } from 'context/FundOwnershipContext';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { FundOwnershipCell } from 'pages/CapTable/fund-ownership/types';
import { FundOwnershipTableAlias } from 'pages/CapTable/fund-ownership/utilities/rowConfig';
import { RelatedEntity } from 'pages/ValuationsAllocation/types';

const FundEntityListValueViewer = (props: { cell: FundOwnershipCell }) => {
  const { cell } = props;
  const { fundEntityListValues, setFundEntityListValues } = useFundOwnershipContext();

  const [globalStore] = useStore() as any;

  const { fundList, companyInfo } = globalStore;

  const cellValueForEntity = useMemo(
    () =>
      Object.values(cell.sheet?.cells ?? {}).find(
        c => c.alias === FundOwnershipTableAlias.ENTITY_REFERENCE && c.columnLegend === cell.columnLegend
      ) as ICell,
    [cell.sheet?.cells, cell.columnLegend]
  );

  const updateFundEntityListValues = useCallback(() => {
    if (!cellValueForEntity) {
      return;
    }

    const tmpOptions = [];

    const isPrimaryCompany = `${cellValueForEntity.value}` === `${companyInfo.id}`;

    if (Array.isArray(fundList)) {
      fundList.forEach(fund => {
        tmpOptions.push({
          id: fund.id,
          value: fund.id,
          label: fund.name,
        });
      });
    }

    if (isPrimaryCompany) {
      const options = (companyInfo.child_companies ?? []).map((child: RelatedEntity) => ({
        id: child.company_id,
        value: child.company_id,
        label: child.company_name,
      }));
      tmpOptions.push(...options);
    }

    setFundEntityListValues(tmpOptions, cell.columnLegend!);
  }, [cellValueForEntity, companyInfo, fundList, setFundEntityListValues, cell.columnLegend]);

  useEffect(() => {
    updateFundEntityListValues();
  }, [cellValueForEntity.value, updateFundEntityListValues]);

  return <SelectValueViewer {...props} options={fundEntityListValues[cell.columnLegend!]} />;
};

export default FundEntityListValueViewer;
